import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listReportStatus } from '@/api/dict.js';
import { listReportOrder, listReportOrderDetail, listReportOrderExport } from '@/api/report.js';
import { listDealerUserManufacturer } from '@/api/manufacturer.js';
import dayjs from 'dayjs';
import YTable from '@/views/components/table/index.vue';
export default {
  name: 'report-center-index',
  components: {
    YTable: YTable
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.initialized) {
        vm.loadData();
      }
    });
  },
  data: function data() {
    return {
      dataList: [],
      // 订单列表
      dataLoading: false,
      initialized: false,
      searchForm: {
        deliveryOrderNo: null,
        // 订单编号
        status: null,
        // 状态 1=暂存,2=提交,3=部分发货,4=全部发货,5=作废,6=结单,7=待审核,8=暂存,9=驳回
        tradeDateStart: null,
        // 销售日期
        tradeDateEnd: null,
        distributorId: null,
        // 分销商ID
        dateRange: ['', ''],
        dateRange2: ['', ''],
        // 手术日期
        invoiceNumber: null,
        // 发票号
        remarks: null,
        // 备注
        page: 1,
        pageSize: 5,
        total: 0
      },
      statusList: [],
      // 状态列表
      manufacturerList: [],
      // 经销商列表
      searchFormExpand: false,
      // 是否展开搜索表单
      detailList: [],
      // 订单产品列表
      detailLoading: false,
      // 订单产品列表loading
      detailForm: {
        sellOrderId: null,
        page: 1,
        pageSize: 5,
        total: 0
      },
      dataTableCurrentRow: null,
      detailTableCurrentRow: null,
      dataTableCacheName: 'SC-' + this.$route.name + '-data-table',
      detailTableCacheName: 'SC-' + this.$route.name + '-detail-table',
      columns: [{
        label: '报台单号',
        prop: 'deliveryOrderNo',
        checked: true,
        width: 200
      }, {
        label: '经销商',
        prop: 'distributorName',
        checked: true,
        width: 200
      }, {
        label: '客户名称',
        prop: 'clientName',
        checked: true,
        width: 200
      }, {
        label: '状态',
        prop: 'status',
        checked: true,
        width: 100,
        slot: 'status'
      }, {
        label: '报台日期',
        prop: 'tradeDate',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return dayjs(val).format('YYYY-MM-DD');
        }
      }, {
        label: '数量',
        prop: 'num',
        checked: true,
        width: 100
      }, {
        label: '医院售价',
        prop: 'sumPrice',
        checked: true,
        width: 150,
        formatter: function formatter(val) {
          return Number(val).toFixed(2);
        }
      }, {
        label: '备注',
        prop: 'remarks',
        checked: true,
        width: 200
      }, {
        label: '操作',
        prop: 'operations',
        checked: true,
        width: 100,
        fixed: 'right',
        slot: 'operations'
      }],
      detailColumns: [{
        label: '产品编号',
        prop: 'productNumber',
        checked: true,
        width: 150
      }, {
        label: '产品名称',
        prop: 'productName',
        checked: true,
        width: 150
      }, {
        label: '规格型号',
        prop: 'specificationModel',
        checked: true,
        width: 200
      }, {
        label: '单位',
        prop: 'unit',
        checked: true,
        width: 100
      }, {
        label: '批号',
        prop: 'batchNumber',
        checked: true,
        width: 100
      }, {
        label: '序列号',
        prop: 'trackingCode',
        checked: true,
        width: 100
      }, {
        label: '数量',
        prop: 'deliveryQuantity',
        checked: true,
        width: 100
      }, {
        label: '医院单价',
        prop: 'hospitalUnitPrice',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return Number(val).toFixed(2);
        }
      }, {
        label: '医院售价',
        prop: 'hospitalSumPrice',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return Number(val).toFixed(2);
        }
      }, {
        label: '注册/备案证',
        prop: 'registrationNumber',
        checked: true,
        width: 200
      }, {
        label: '厂家',
        prop: 'manufacturer',
        checked: true,
        width: 200
      }, {
        label: '通用名称',
        prop: 'genericName',
        checked: true,
        width: 120,
        fixedWidth: true
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.dataLoading = false;
                that.statusList = listReportStatus();
                _context.next = 5;
                return that.loadManufacturer();

              case 5:
                if (that.initialized) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return that.loadData();

              case 8:
                that.initialized = true;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                that.dataList = [];
                that.detailList = [];
                that.dataLoading = true;
                query = JSON.parse(JSON.stringify(that.searchForm));

                if (query.dateRange) {
                  if (query.dateRange[0] && query.dateRange[1]) {
                    query.tradeDateStart = query.dateRange[0];
                    query.tradeDateEnd = query.dateRange[1];
                  }

                  delete query.dateRange;
                }

                if (query.dateRange2) {
                  if (query.dateRange2[0] && query.dateRange2[1]) {
                    query.operationTimeStart = query.dateRange2[0];
                    query.operationTimeEnd = query.dateRange2[1];
                  }

                  delete query.dateRange2;
                }

                _context2.next = 9;
                return listReportOrder(query).then(function (res) {
                  res.list.map(function (row) {
                    row.clientName = row.dealerClient.username;
                  });
                  that.dataList = res.list;
                  that.searchForm.total = res.total;

                  if (that.dataTableCurrentRow) {
                    that.$refs.dataTableRef.setCurrentRow(that.dataTableCurrentRow, true);
                  }
                }).catch(function (e) {});

              case 9:
                that.dataLoading = false;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    dataExport: function dataExport() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                form = JSON.parse(JSON.stringify(that.searchForm));
                form.toExcel = 1;
                _context3.next = 5;
                return listReportOrderExport(form).then(function (res) {
                  var blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
                  }); // type这里表示xlsx类型

                  // type这里表示xlsx类型
                  var downloadElement = document.createElement('a');
                  var href = window.URL.createObjectURL(blob); // 创建下载的链接

                  // 创建下载的链接
                  downloadElement.href = href;
                  downloadElement.download = '报台单.xlsx'; // 下载后文件名

                  // 下载后文件名
                  document.body.appendChild(downloadElement);
                  downloadElement.click(); // 点击下载

                  // 点击下载
                  document.body.removeChild(downloadElement); // 下载完成移除元素

                  // 下载完成移除元素
                  window.URL.revokeObjectURL(href); // 释放掉blob对象
                }).catch(function () {});

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    searchFormSubmit: function searchFormSubmit() {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.total = 0;
      that.loadData();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.searchForm.pageSize = pageSize;
      that.searchForm.page = 1;
      that.loadData();
    },
    dataRowClick: function dataRowClick(row) {
      var that = this;
      that.dataTableCurrentRow = row;
      that.detailForm.page = 1;
      that.detailForm.total = 0;
      that.detailForm.sellOrderId = row.ID;
      that.loadDetail();
    },
    dataRowDbClick: function dataRowDbClick(row) {
      var that = this;
      that.dataTableCurrentRow = row;
      that.dataEdit(row);
    },
    dataCreate: function dataCreate() {
      var that = this;
      that.$router.push({
        path: '/report/center/create'
      });
    },
    dataEdit: function dataEdit(row) {
      var that = this;
      that.$router.push({
        path: '/report/center/detail/' + row.ID
      });
    },
    loadManufacturer: function loadManufacturer() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                that.manufacturerList = [];
                _context4.next = 4;
                return listDealerUserManufacturer().then(function (res) {
                  that.manufacturerList = res.list;
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    loadDetail: function loadDetail() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                that.detailList = [];
                that.detailLoading = true;
                query = {
                  deliveryId: that.dataTableCurrentRow.ID,
                  page: 1,
                  pageSize: 9999
                };
                _context5.next = 6;
                return listReportOrderDetail(query).then(function (res) {
                  res.list.map(function (row) {
                    that.detailList.push({
                      ID: row.ID,
                      productNumber: row.specs.productNumber,
                      productName: row.main.productName,
                      specificationModel: row.specs.specificationModel,
                      unit: row.specs.unit,
                      deliveryQuantity: row.deliveryQuantity,
                      hospitalUnitPrice: row.hospitalUnitPrice,
                      hospitalSumPrice: row.hospitalSumPrice,
                      registrationNumber: row.main.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      batchNumber: row.inventory.batch_number,
                      trackingCode: row.inventory.trackingCode,
                      genericName: row.specs.genericName
                    });
                  });
                  that.detailForm.total = res.total;

                  if (that.detailTableCurrentRow) {
                    that.$refs.detailTableRef.setCurrentRow(that.detailTableCurrentRow, true);
                  }
                }).catch(function (e) {});

              case 6:
                that.detailLoading = false;

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    detailPageChange: function detailPageChange(page) {
      var that = this;
      that.detailForm.page = page;
    },
    detailSizeChange: function detailSizeChange(pageSize) {
      var that = this;
      that.detailForm.pageSize = pageSize;
      that.detailForm.page = 1;
    },
    detailRowClick: function detailRowClick(row) {
      var that = this;
      that.detailTableCurrentRow = row;
    },
    statusFormatter: function statusFormatter(row) {
      var findRow = this.statusList.find(function (item) {
        return item.ID === row.status;
      });

      if (findRow) {
        return '<a class="el-link el-link--' + findRow.type + '"><span class="el-link--inner">' + findRow.name + '</span></a>';
      } else {
        return row.status;
      }
    },
    selectable: function selectable(row) {
      var that = this;
      var rows = that.$refs.dataTableRef.selections();

      if (rows.length > 0) {
        var findRow = rows.find(function (item) {
          return item.manu.ID === row.manu.ID;
        });

        if (findRow) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    oneKeyReplenishment: function oneKeyReplenishment() {
      var that = this;
      var rows = that.$refs.dataTableRef.selections();

      if (rows.length === 0) {
        that.$message.error('请选择订单');
        return;
      }

      var batchReplenishmentIds = [];
      rows.map(function (row) {
        batchReplenishmentIds.push(row.ID);
      });
      console.log('batchReplenishmentIds', batchReplenishmentIds);
      that.$router.push({
        name: 'order-consign-create',
        params: {
          batchReplenishmentIds: batchReplenishmentIds,
          distributorId: rows[0].distributorId
        }
      });
    }
  }
};